<template>
    <v-dialog
        v-model="value"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        scrollable
    >
        <div>
            <v-card tile class="dialog-card">
                <div>
                <v-toolbar
                    flat
                >
                    <v-toolbar-title>Список услуг</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="$emit('input', false)"
                    >
                        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M32.251 30.2926C32.3439 30.3855 32.4176 30.4958 32.4679 30.6172C32.5182 30.7386 32.5441 30.8687 32.5441 31.0001C32.5441 31.1315 32.5182 31.2616 32.4679 31.383C32.4176 31.5044 32.3439 31.6147 32.251 31.7076C32.1581 31.8005 32.0478 31.8742 31.9264 31.9245C31.805 31.9747 31.6749 32.0006 31.5435 32.0006C31.4121 32.0006 31.282 31.9747 31.1606 31.9245C31.0392 31.8742 30.9289 31.8005 30.836 31.7076L22.5435 23.4138L14.251 31.7076C14.0634 31.8952 13.8089 32.0006 13.5435 32.0006C13.2782 32.0006 13.0237 31.8952 12.836 31.7076C12.6484 31.5199 12.543 31.2654 12.543 31.0001C12.543 30.7347 12.6484 30.4802 12.836 30.2926L21.1298 22.0001L12.836 13.7076C12.6484 13.5199 12.543 13.2654 12.543 13.0001C12.543 12.7347 12.6484 12.4802 12.836 12.2926C13.0237 12.1049 13.2782 11.9995 13.5435 11.9995C13.8089 11.9995 14.0634 12.1049 14.251 12.2926L22.5435 20.5863L30.836 12.2926C31.0237 12.1049 31.2782 11.9995 31.5435 11.9995C31.8089 11.9995 32.0634 12.1049 32.251 12.2926C32.4387 12.4802 32.5441 12.7347 32.5441 13.0001C32.5441 13.2654 32.4387 13.5199 32.251 13.7076L23.9573 22.0001L32.251 30.2926Z" fill="#DA251C"/>
                        </svg>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="repair-list">
                    <div class="repair-types-select">
                        <div v-for="type in repairTypes" :key="type.id" class="repair-type" :class="{'active': selectedRepairTypeId === type.id}" @click="$emit('selectRepairTypeId', type)">
                            <!-- добавить иконку типа -->
                            {{type.name}}
                        </div>
                    </div>
                    <v-list>
                        <v-list-item
                            v-for="repair in repairs"
                            :disabled="repair.disabled"
                            :key="`repair_${repair.id}`"
                            @click="toggleRepair(repair)">
                            <v-list-item-action>
                                <v-checkbox
                                    v-model="localSelectedRepairs"
                                    :value="repair.id"
                                    color="#DA251C"
                                    class="repair-checkbox"
                                    :class="{'active': localSelectedRepairs.includes(repair.id)}"
                                    hide-details
                                />
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ repair.name }}
                                </v-list-item-title>
                                <v-list-item-subtitle style="text-wrap: wrap;font-size:0.8rem;">
                                    {{ repair.description }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                </div>
                <v-spacer />
                <v-card-actions class="card-actions">
                    <div class="step-action">
                        <v-btn
                            @click="$emit('update:selectedRepairs', localSelectedRepairs);$emit('input', false);"
                            elevation="0"
                        >
                            Выбрать услуги
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </div>
    </v-dialog>
</template>

<script>
    import {
        filter as _filter,
    } from 'lodash'

    export default {
        name: 'SelectRepairDialog',

        props: {
            value: Boolean,
            repairTypes: Array,
            repairs: Array,
            selectedRepairs: Array,
            selectedRepairTypeId: String,
        },

        data: () => ({
            localSelectedRepairs: [],
        }),

        computed: {
            //
        },
        watch: {
            selectedRepairs() {
                this.localSelectedRepairs = this.selectedRepairs
            },
            value() {
                this.localSelectedRepairs = this.selectedRepairs
            },
        },

        methods: {
            toggleRepair(repair) {
                this.$emit('toggleRepair', repair)
            },
            addRepair(repairId) {
                if (repairId) {
                    this.localSelectedRepairs.push(repairId)
                }
            },

            removeRepair(repairId) {
                this.localSelectedRepairs = _filter(this.localSelectedRepairs, id => id !== repairId)
            },
        },

    }
</script>

<style scoped>
    .selected-repairs {
        display: flex;
        gap: 8px;
        margin-top: 28px;
        margin-left: 64px;
    }
    .selected-repair {
        display: flex;
        padding: 8px 20px;
        justify-content: center;
        align-items: center;
        gap: 5px;
        border-radius: 24px;
        border: 1px solid #F3F4F4;
        background: #F3F4F4;
        color: #36393B;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 140%;
    }
    .repair-types-select {
        display: flex;
        gap: 12px;
        overflow-x: auto;
        padding-bottom: 16px;
    }
    .repair-type {
        display: flex;
        padding: 7px 18px;
        justify-content: center;
        align-items: center;
        gap: 6px;
        border-radius: 36px;
        background: #FFF;
        color: #36393B;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
        cursor: pointer;
        white-space: nowrap;
    }
    .repair-type.active {
        background: #DA251C;
        color: #FFF;
        cursor: default;
    }
    .step-action {
        margin: 0 16px;
        /* padding-bottom: 18px; */
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }
    .step-action .v-btn {
        display: flex;
        padding: 16px 40px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 10px;
        border: 2px solid #DA251C;
        background: #DA251C;
        width: 283px;
        height: 52px;
        color: #FFF;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .mobile .step-action .v-btn {
        width: 100%;
    }
    .step-action .v-btn.v-btn--disabled {
        background: #F3F4F4 !important;
        border-color: #F3F4F4 !important;
        color: #36393B !important;
    }
    .card-actions {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 88px;
        background: #fff;
    }
    .dialog-card {
        width: 100vw;
        display: flex;
        flex-direction: column;
        min-height: 100vh;
    }
    .repair-list {
        padding-bottom: 88px;
    }
</style>
